/** Legacy bundled placeholders — not treated as uploaded event art. */
export const PLACEHOLDER_POSTER_PATHS = [
    "/assets/poster.jpg",
    "/assets/poster.png",
];
/** True when the URL is a real uploaded or custom poster (not empty or bundled placeholder). */
export function isRealEventPoster(url) {
    if (!url?.trim())
        return false;
    const normalized = url.trim();
    return !PLACEHOLDER_POSTER_PATHS.includes(normalized);
}
//# sourceMappingURL=eventPoster.js.map